export const ROUTE_NAMES = {};
export const FORM_IDS = {
	REVENUE: 'revenue',
	COMPANY_TYPE: 'company-type',
	SZECHENYI_CARD: 'szechenyi-card',
	OFFER_SIMPLE: 'offer-simple',
	OFFER_BOOK_APPOINTMENT: 'offer-book-appointment',
	BUSINESS_ACTIVITY: 'business-activity',
	OFFER_CUSTOM_COMPANY_TYPE: 'offer-custom-company-type',
	OFFER_TABLE: 'offer-table',
	OFFER_SUCCESS: 'success',
	OFFER_FAILURE: 'failure',
	TECHNICAL_ERROR: 'technical-error',
	OFFER_SENDING: 'offer-sending',
	DOWNLOAD_PDF: 'download-pdf'
};

export const EVENTS = {
	TECHNICAL_ERROR: 'TECHNICAL_ERROR',
	YES: 'YES',
	NO: 'NO',
	COMPANY_TYPE_SELECTED: 'COMPANY_TYPE_SELECTED',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE',
	ACTIVITY_SELECTED: 'ACTIVITY_SELECTED',
	SEND_OFFER: 'SEND_OFFER',
	GET_OFFER: 'GET_OFFER',
	CAPTCHA_ERROR: 'CAPTCHA_ERROR',
	RESET: 'RESET',
	RETRY: 'RETRY',
	DOWNLOAD_PDF: 'DOWNLOAD_PDF'
};
